<template>
  <div class="flex items-center">
    <span>{{ getValue }}</span>
  </div>
</template>

<script>
export default {
  name: "CellRendererAccounts",
  computed: {
    getValue() {
      return this.$t("TableTotalAccounts", { count: this.params.value.length });
    }
  }
};
</script>
